/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 07/26/2021
 *
 * @version 0.1
 * Revisions:
 * 07/26/2021 - BW - Initial Creation
 *
 * Description/Purpose:
 * Count Down Timer Class
 ************************************************************** */

import StackTraceError from "component/stack-trace-error/stack-trace-error";
import PUBSUB_EVENT from "constant/pubsub-event";
import PubSub from 'pubsub-js';

export default class CountDownTimer {
  /**
     * Constructor
     * @param countDownMins
     */
  constructor(countDownMins) {
    try {
      this.countDownMins = countDownMins;

      this.init();
    } catch (e) {
      StackTraceError.processError(e, 'Count Down Timer - Constructor');
    }
  }


  /**
     * Init
     * @returns {CountDownTimer}
     */
  init() {
    this._setUpVariable();
    return this;
  }


  /**
     * Set up some common variables
     * @private
     */
  _setUpVariable() {
    try {
      this._intervalId = null;
      this._now = null; // current date
      this._count = 0; // used to count the iterations
      this._endDateTime = null;
    } catch (e) {
      StackTraceError.processError(e, 'Count Down Timer - Set Up Variable');
    }
  }


  /**
     * Starts the countdown
     * @param $elem
     */
  start($elem) {
    this.$elem = $elem;
    this._now = new Date();
    this._count = 0;
    this._endDateTime = new Date(this._now.getTime() + (this.countDownMins * 60 * 1000)).getTime();
    this.run();
    this._intervalId = setInterval(this.run.bind(this), 1000); // call every second
  }


  /**
     * Stops the countdown
     */
  stop() {
    clearInterval(this._intervalId);
    this._intervalId = null;
  }


  /**
     * Is the countdown still running?
     * @returns {boolean}
     */
  isRunning() {
    return !(this._intervalId === null || this._intervalId === '');
  }


  /**
     * Runs the countdown
     */
  run() {
    const startDateTime = new Date(this._now.getTime() + (this._count++ * 1000)).getTime();
    console.log(`${this._endDateTime} -- ${startDateTime}`);
    const diff = this._endDateTime - startDateTime;
    let minute = Math.floor((diff/1000/60) % 60);
    let second = Math.floor((diff/1000) % 60);
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;

    // Update the $elem
    const html = `${minute}:${second}`;
    this.$elem.html(html);
    console.log(`diff: ${diff}`, `${minute}:${second}`);

    // Once the diff is less than 0 - stop the interval and fire an event
    if (diff <= 0) {
      this.stop();
      // Fire the event
      PubSub.publish(PUBSUB_EVENT.COUNT_DOWN_TIMER_DONE, this.$elem);
      // fireEvent( "countDownTimerDoneEvent", $elem );
    } else {
      // Fire the event
      PubSub.publish(PUBSUB_EVENT.COUNT_DOWN_TIMER_RUNNING, [this.$elem, html]);
      // fireEvent( "countDownTimerRunningEvent", [$elem, html] );
    }
  }
}
